import Container from 'react-bootstrap/Container';
import Spinner from 'react-bootstrap/Spinner';

export const LoadingScreen = ({ message = 'Loading...' }) => (
    <Container className="d-flex flex-column align-items-center justify-content-center" style={{ minHeight: '100vh' }}>
        <Spinner animation="border" variant="primary" className="mb-3" />
        <p className="text-muted">{message}</p>
    </Container>
);
